/**
 * Display label for a leaderboard row, shared by the per-map panel and the
 * season boards so the same player is never labelled two different ways. A
 * signed-in player who hasn't set a name shows "Player"; a guest shows
 * "Guest". Whitespace-only names count as unset.
 */
export function leaderboardDisplayName(entry: {
  displayName: string | null;
  isAnonymous: boolean;
}): string {
  if (entry.displayName && entry.displayName.trim().length > 0) {
    return entry.displayName;
  }
  return entry.isAnonymous ? 'Guest' : 'Player';
}
